var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"page-header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"flex-row justify-between flex-center"},[_c('company-logo',{on:{"click":_vm.logoLink}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }